export default __webpack_public_path__ + "static/Requirement-Gathering-a021be259d86c829eddd91ae642af953.svg";